class DataCaller {
    private baseUrl: string;
    private token: string;

    constructor(baseUrl: string, token: string) {
        this.baseUrl = baseUrl;
        this.token = token;
    }

    async create(data: any): Promise<any> {
        const response = await fetch(`${this.baseUrl}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${this.token}`,
            },
            body: JSON.stringify(data),
        });
        return response;
    }

    async get(id: string): Promise<any> {
        const response = await fetch(`${this.baseUrl}/${id}`, {
            headers: {
                Authorization: `Bearer ${this.token}`,
            },
        });
        return response;
    }

    async getAll(): Promise<any> {
        const response = await fetch(`${this.baseUrl}`, {
            headers: {
                Authorization: `Bearer ${this.token}`,
            },
        });
        return response;
    }

    async update(id: string, data: any): Promise<any> {
        const response = await fetch(`${this.baseUrl}/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${this.token}`,
            },
            body: JSON.stringify(data),
        });
        return response;
    }

    async delete(id: string): Promise<any> {
        const response = await fetch(`${this.baseUrl}/${id}`, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${this.token}`,
            },
        });
        return response;
    }
}

export default DataCaller;
